var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-month"},[_c('BtnToggle',{staticClass:"calendar-month__months",attrs:{"value":_vm.month,"options":_vm.monthsOptions},on:{"input":_vm.setMonth,"click-self":_vm.selected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }